/** Emotion presets (ARKit morph targets on Head_Mesh and accessory meshes). */
export const EMOTION_BLENDSHAPES = {
  joy: [
    {
      intensity: 1,
      meshes: {
        Head_Mesh: {
          mouthSmile: 0.25,
          cheekSquintLeft: 0.12,
          cheekSquintRight: 0.12,
          eyeSquintLeft: 0.08,
          eyeSquintRight: 0.08,
          browInnerUp: 0.05
        }
      }
    },
    {
      intensity: 2,
      meshes: {
        Head_Mesh: {
          mouthSmile: 0.4,
          cheekSquintLeft: 0.5,
          cheekSquintRight: 0.5,
          eyeSquintLeft: 0.3,
          eyeSquintRight: 0.3,
          browOuterUpLeft: 0.16,
          browOuterUpRight: 0.16,
          browInnerUp: 0.14
        }
      }
    },
    {
      intensity: 3,
      meshes: {
        Head_Mesh: {
          mouthSmile: 0.7,
          cheekSquintLeft: 0.82,
          cheekSquintRight: 0.82,
          eyeSquintLeft: 0.58,
          eyeSquintRight: 0.58,
          browOuterUpLeft: 0.32,
          browOuterUpRight: 0.32,
          browInnerUp: 0.28
        }
      }
    }
  ],
  sadness: [
    {
      intensity: 1,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.14,
          mouthFrownLeft: 0.25,
          mouthFrownRight: 0.25,
          browDownLeft: 0.1,
          browDownRight: 0.1
        }
      }
    },
    {
      intensity: 2,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.48,
          mouthFrownLeft: 0.4,
          mouthFrownRight: 0.5,
          browDownLeft: 0.32,
          browDownRight: 0.32
        }
      }
    },
    {
      intensity: 3,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.78,
          mouthFrownLeft: 0.8,
          mouthFrownRight: 0.8,
          browDownLeft: 0.62,
          browDownRight: 0.62
        }
      }
    }
  ],
  anger: [
    {
      intensity: 1,
      meshes: {
        Head_Mesh: {
          mouthShrugUpper: 0.2,
          browDownLeft: 0.16,
          browDownRight: 0.4,
          noseSneerLeft: 0.4,
          noseSneerRight: 0.3,
          eyeSquintLeft: 0.22,
          eyeSquintRight: 0.22,
          mouthPressLeft: 0.2,
          mouthPressRight: 0.2
        }
      }
    },
    {
      intensity: 2,
      meshes: {
        Head_Mesh: {
          mouthShrugUpper: 0.5,
          browDownLeft: 0,
          browDownRight: 0.58,
          noseSneerLeft: 0.45,
          noseSneerRight: 0.45,
          eyeSquintLeft: 0.48,
          eyeSquintRight: 0.48,
          mouthPressLeft: 0.42,
          mouthPressRight: 0.42
        }
      }
    },
    {
      intensity: 3,
      meshes: {
        Head_Mesh: {
          mouthShrugUpper: 0.7,
          browDownLeft: 0.95,
          browDownRight: 0.95,
          noseSneerLeft: 0.82,
          noseSneerRight: 0.82,
          eyeSquintLeft: 0.88,
          eyeSquintRight: 0.88,
          mouthPressLeft: 0.82,
          mouthPressRight: 0.82
        }
      }
    }
  ],
  surprise: [
    {
      intensity: 1,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.5,
          browOuterUpLeft: 0.5,
          browOuterUpRight: 0.5,
          viseme_aa: 0.2,
          viseme_RR: 0.2
        },
        Tongue_Mesh: {
          mouthOpen: 0.8
        },
        Teeth_Mesh: {
          mouthOpen: 0.8
        }
      }
    },
    {
      intensity: 2,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.6,
          browOuterUpLeft: 0.6,
          browOuterUpRight: 0.6,
          viseme_aa: 0.3,
          viseme_RR: 0.3
        },
        Tongue_Mesh: {
          mouthOpen: 0.8
        },
        Teeth_Mesh: {
          mouthOpen: 0.8
        }
      }
    },
    {
      intensity: 3,
      meshes: {
        Head_Mesh: {
          browInnerUp: 0.88,
          browOuterUpLeft: 0.85,
          browOuterUpRight: 0.85,
          viseme_aa: 0.5,
          viseme_RR: 0.5
        },
        Tongue_Mesh: {
          mouthOpen: 0.8
        },
        Teeth_Mesh: {
          mouthOpen: 0.8
        }
      }
    }
  ]
};

/** Rig mesh names shared by emotion, lipsync, and avaturn clip stripping. */
export const EMOTION_MESH_NAME = {
  head: 'Head_Mesh',
  teeth: 'Teeth_Mesh',
  /** Accessory meshes whose avaturn_animation morph tracks are fully removed. */
  avaturnStripped: ['Teeth_Mesh', 'Tongue_Mesh']
};

/**
 * Head_Mesh morphs avaturn_animation may keep driving.
 * All other Head_Mesh morph tracks are stripped from the body clip.
 */
export const AVATURN_ANIMATED_FACE_MORPH_NAMES = [
  'eyeLookDownLeft',
  'eyeLookDownRight',
  'eyeLookUpLeft',
  'eyeLookUpRight',
  'eyeLookInLeft',
  'eyeLookInRight',
  'eyeLookOutLeft',
  'eyeLookOutRight',
  'eyeBlinkLeft',
  'eyeBlinkRight',
  'eyeSquintLeft',
  'eyeSquintRight',
  'browDownRight',
  'browDownLeft'
];

export const EMOTION_BLENDSHAPE_PATTERN = {
  lipsyncMouth: /^(jaw|mouth|tongue|viseme_|mouthOpen)/i,
  speechSafeMouth: /^(mouthSmile|mouthFrown|mouthDimple)/i
};

/** Mouth-corner morphs lipsync must not zero when resetting after speech. */
export const SPEECH_SAFE_MOUTH_PRESERVE_NAMES = [
  'mouthSmile',
  'mouthSmileLeft',
  'mouthSmileRight',
  'mouthFrownLeft',
  'mouthFrownRight',
  'mouthDimpleLeft',
  'mouthDimpleRight'
];
